<template>
  <div>
    <ReCaptchaErrorDialog v-if="hasReCaptchaError"></ReCaptchaErrorDialog>

    <div class="content">
      <LoginLogo />

      <v-form ref="form" v-bind:disabled="!currentUsername || formSubmitted" v-on:submit.prevent="completePassword" data-cy="completePassword-form">
        <v-container>



          <v-row v-if="currentUsername" class="text-truncate justify-center" data-cy="completePassword-username">
            <v-tooltip location="bottom" z-index="1200">
              <template v-slot:activator="{ props }">
                <span v-bind="props" class="mb-2">
                  <b>{{currentUsername}}</b>
                </span>
              </template>
              <span>{{currentUsername}}</span>
            </v-tooltip>
          </v-row>

          <v-row class="justify-center">
            <span class="mb-2">
              Please set a new password.
            </span>
          </v-row>

          <v-row v-if="!currentUsername && !ignoreNoUser" class="bg-error my-4" >
            Invalid user! Go to the &nbsp;<router-link to="/account/login">login page</router-link>.
          </v-row>

          <v-row v-if="errorMessage" class="bg-error my-4" >
            {{errorMessage}}
          </v-row>

          <v-row>
            <v-text-field
              type="password"
              label="password"
              v-model="password"
              v-bind:rules="passwordRules"
              prepend-inner-icon="mdi-lock"
              variant="solo-filled"
              flat block required
              data-cy="completePassword-password">
            </v-text-field>
          </v-row>

          <v-row>
            <v-text-field
              type="password"
              label="confirm password"
              v-model="repassword"
              v-bind:rules="[passwordConfirmationRule]"
              prepend-inner-icon="mdi-lock"
              variant="solo-filled"
              required flat block
              data-cy="completePassword-confirmPassword">
            </v-text-field>
          </v-row>

          <v-row>
            <v-btn
            type="submit"
            class="bg-primary"
            :disabled="ignoreNoUser"
            block
            data-cy="completePassword-btn"
            >
              Update Password
            </v-btn>
          </v-row>
        </v-container>
      </v-form>

      <!-- <div class="text-center mt-3">
        <router-link to="/account/forgot-password">Forgot password?</router-link>
      </div> -->
    </div>

  </div>
</template>

<script>
import { useAuthStore } from '@/stores/AuthStore'
import CognitoRedirectingMixin from './CognitoRedirectingMixin.js'
import LoginLogo from './components/LoginLogo.vue'
import Helper from '../../components/helper.js';
import ReCaptchaErrorDialog from '@/routes/account/components/ReCaptchaErrorDialog.vue';

export default {
  name: "CompletePassword",
  mixins: [CognitoRedirectingMixin],
  components: {
    ReCaptchaErrorDialog,
    LoginLogo,
  },
  data: function() {
    return {
      password: "",
      passwordRules: Helper.getPasswordRules(this),

      repassword: "",

      errorMessage: "",

      formSubmitted: false,
      ignoreNoUser: false,
      hasReCaptchaError: false,
    };
  },
  mounted: async function () {
    if (!this.currentUsername) {
      this.$router.push('/account/login');
    }

    this.$recaptchaOnError(() => {
      this.hasReCaptchaError = true;
    });

    try {
      await this.$recaptchaLoaded();
      this.$recaptchaShowBadge();
      // eslint-disable-next-line no-unused-vars
    } catch (_) {
      this.hasReCaptchaError = true;
    }
  },
  beforeUnmount: async function() {
    this.$recaptchaHideBadge();
  },
  methods: {
    completePassword: async function() {
      this.errorMessage = "";
      const validForm = await this.$refs.form.validate();

      if (!validForm.valid || !window.tempCredentials || this.formSubmitted) {
        return;
      }

      try {
        this.formSubmitted = true;
        this.ignoreNoUser = true;

        // Execute reCAPTCHA with action "login".
        const captchaToken = await this.$recaptcha('login');

        const params = {
          // email: this.currentUser.username,
          password: this.password,
          // oldPassword: this.currentUser.vbTempPassword,
          options: {
            clientMetadata: {
              captcha: captchaToken,
            },
          },
        };

        const authStore = useAuthStore();
        const cognitoResponse = await authStore.completePassword(params);

        await this.cognitoRedirectingMixin(cognitoResponse, window.tempCredentials.username);
      } catch (e) {
        console.log("error completing the password", e);
        this.errorMessage = "An error occurred!";
      } finally {
        this.ignoreNoUser = false;
        this.formSubmitted = false;
      }
    }
  },
  computed: {
    passwordConfirmationRule: function() {
      return this.password === this.repassword || "Please, retype the password correctly.";
    },
    currentUsername: function() {
      if (window && window.tempCredentials && window.tempCredentials.username) {
        return window.tempCredentials.username;
      }

      return false;
    },
  },
}
</script>

<style>

</style>
